import HttpService from '../base.service/HttpService'

export default class RoleService extends HttpService {
  getRoleList () {
    const api = process.env.VUE_APP_API + '/role/list'
    return this.get({}, api)
  }

  addData (param) {
    const api = process.env.VUE_APP_API + '/role/add'
    return this.post(param, api)
  }
}
